import EventBus from '../../../shared/js/wirebox/event-bus'
import LazyLoad from 'vanilla-lazyload'

EventBus.subscribe('run-modules', () => {
    new LazyLoad()
})